import React from 'react';
import Card from 'components/Card/Card.jsx';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import FitnessUploader from './FileTypes/FitnessUploader';
import InsuranceUploader from './FileTypes/InsuranceFileUploader';
import RCUploader from './FileTypes/RCUploader';
import InsuranceExpiry from './FileTypes/InsuranceExpiry';
import myFirebase from '../../../config/config';
import TruckImage from '../../../assets/icons/Truck.svg';
import SmartClubLabel from '../../../components/Common/SmartClubMembership';

const headerTextTitleStyles = {
  margin: 8,
  fontSize: '16px',
  fontWeight: 'bold',
  color: 'white',
};

const db = myFirebase.firestore();
const TruckFilesUpload = ({
  selectedTrucker,
  activeRole,
  userDetails,
  truck,
  featureFlagFiles,
  refetch,
}) => {
  const truckData = truck?.truckData || {};

  const rcFileUploaded = truckData?.rc_card ?? false;
  const status =
    (truckData?.rc_card ?? false) && truckData?.status === 'approved';

  const headerStyles = {
    background: status ? '#3DAC16' : '#FF7E03',
    borderRadius: '5px 5px 0px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const statusStyle = {
    color: 'white',
    paddingRight: '8px',
    textTransform: 'capitalize',
  };

  return (
    <Grid item xs={12} lg={4}>
      <Card
        style={{
          borderRadius: '5px',
          border: status ? '2px solid #3DAC16' : '2px solid #FF7E03',
          margin: '0',
        }}
      >
        <div style={headerStyles}>
          <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
            <h3 style={headerTextTitleStyles}>{truck.data[0]}</h3>
            {truckData?.is_smart_club_membership && <SmartClubLabel />}
          </div>
          <Typography style={statusStyle}>
            {truckData?.status === 'pending'
              ? 'Approval Pending'
              : truckData?.status}
          </Typography>
        </div>
        <div style={{ padding: '10px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2} style={{ display: 'flow' }}>
                <Grid item>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src={TruckImage}
                      alt="icon"
                      style={{ marginRight: '10px' }}
                    />
                    <Typography variant="body1">{truck.data[1]}</Typography>
                  </div>
                </Grid>
                <Grid item>
                  <RCUploader
                    selectedTrucker={selectedTrucker}
                    truckNumber={truck.data[0]}
                    activeRole={activeRole}
                    userDetails={userDetails}
                    rcFileUploaded={rcFileUploaded}
                    featureFlagFiles={featureFlagFiles}
                    refetch={refetch}
                    truckStatus={truckData?.status}
                  />
                </Grid>

                <Grid item>
                  <FitnessUploader
                    isFitnessUploaded={truckData?.fitness_cert ?? false}
                    selectedTrucker={selectedTrucker}
                    truckNumber={truck.data[0]}
                    activeRole={activeRole}
                    userDetails={userDetails}
                    featureFlagFiles={featureFlagFiles}
                    refetch={refetch}
                    truckStatus={truckData?.status}
                  />
                </Grid>
                <Grid item>
                  <InsuranceUploader
                    isInsuranceUploaded={truckData?.insurance ?? false}
                    selectedTrucker={selectedTrucker}
                    truckNumber={truck.data[0]}
                    activeRole={activeRole}
                    userDetails={userDetails}
                    featureFlagFiles={featureFlagFiles}
                    refetch={refetch}
                    truckStatus={truckData?.status}
                  />
                </Grid>
                <Grid item>
                  <InsuranceExpiry
                    truckData={truckData}
                    activeRole={activeRole}
                    selectedTrucker={selectedTrucker}
                    refetch={refetch}
                    truckStatus={truckData?.status}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Card>
    </Grid>
  );
};

export default TruckFilesUpload;
